import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import NavbarWrapper from "components/Layouts/NavbarWrapper";

const MainApp = () => {
	const location = useLocation();

	if (!location.pathname.split("/").includes("app")) {
		return <Navigate to={`/login?redirectUrl=${encodeURIComponent(location.pathname + location.search)}`} />;
	}
	return (
		<NavbarWrapper isApplicationPortal={location.pathname === "/app/portal"}>
			<Outlet />
		</NavbarWrapper>
	);
};

export default MainApp;
